import React, { FC } from "react";

import NfcSection from "sections/faqPage/NfcSection";
import TreasureHuntSection from "sections/faqPage/TreasureHuntSection";
import BlockchainSection from "sections/faqPage/BlockchainSection";

import Layout from "components/Layout";

const FaqPage: FC = () => {
  return (
    <Layout
      subHeader={{
        header: "Frequently Asked Questions",
        description:
          "Do you have some questions about Uniqly, our products, or others? You are in the right place! Check our FAQ to find out answers to the most popular questions.",
      }}
    >
      <NfcSection />
      <TreasureHuntSection />
      <BlockchainSection />
    </Layout>
  );
};

export default FaqPage;
